<form data-testid="login-form" [formGroup]="loginForm" novalidate>
  <h1 class="text-center auth-heading">
    <a [routerLink]="['/']" class="inline-block">
      <img src="assets/layout/images/wtg-logo-transparent-white.webp" alt="watch-this-garage-logo" class="app-logo">
    </a>
    <small>{{'auth.login.title' | translate}}</small>
  </h1>
  <div class="col-12 p-fluid">
            <span class="p-float-label p-input-icon-left">
              <i class="pi pi-user"></i>
              <input type="text" pInputText data-testid="login-username" id="username" formControlName="username">
              <label for="username">{{'auth.login.username_email' | translate }}</label>
            </span>
  </div>
  <div class="col-12 p-fluid">
              <span class="p-float-label p-input-icon-left">
                <i class="pi pi-key"></i>
                <input pInputText type="password" data-testid="login-password" id="password" formControlName="password">
                <label for="password">{{'auth.login.password' | translate}}</label>
              </span>
    <p *ngIf="error" class="mat-error app-form-error">{{error}}</p>
  </div>
  <div class="col-12 p-fluid">
    <p-checkbox checkboxIcon="pi pi-thumbs-up" [binary]="true" [formControlName]="'remember'"
                [label]="'auth.login.remember' | translate">
    </p-checkbox>
  </div>
  <div class="col-12">
    <p><a [routerLink]="['/reset-password']" class="center">{{'auth.login.forgot' | translate}}</a></p>
  </div>
  <div class="col-12" *ngIf="showInactiveAccountCta">
    <div class="login-resend-box">
      <p class="m-0">{{ 'auth.login.inactive_account.message' | translate }}</p>
      <button pButton pRipple
              type="button"
              icon="pi pi-envelope"
              iconPos="left"
              class="auth-action--secondary mt-3"
              [disabled]="isResendingActivation"
              (click)="resendActivationEmail()"
              [label]="'auth.login.inactive_account.button.resend' | translate">
      </button>
    </div>
  </div>
  <div class="col-12" *ngIf="showInactiveAccountCta">
    <div class="login-resend-box">
      <p class="m-0">{{ 'auth.login.inactive_account.message' | translate }}</p>
      <button pButton pRipple
              type="button"
              icon="pi pi-envelope"
              iconPos="left"
              class="p-button-secondary p-button-outlined p-button-rounded mt-3"
              [disabled]="isResendingActivation"
              (click)="resendActivationEmail()"
              [label]="'auth.login.inactive_account.button.resend' | translate">
      </button>
    </div>
  </div>
  <div class="col-12 p-fluid">
    <button pButton pRipple
            icon="pi pi-sign-in"
            iconPos="left"
            type="submit"
            class="auth-action--primary"
            data-testid="login-submit" (click)="login()"
            [disabled]="loginForm.invalid"
            [label]="'auth.login.button.sign_in' | translate"
    >
    </button>
  </div>
  <div class="col-12 p-fluid">
    <button pButton pRipple
            icon="pi pi-facebook"
            iconPos="left"
            type="button"
            class="auth-action--social"
            (click)="fbLogin()"
            [label]="'auth.login.button.sign_in_with_facebook' | translate"
    >
    </button>
  </div>
  <div class="col-12 p-fluid">
    <button pButton pRipple
            icon="pi pi-google"
            iconPos="left"
            type="button"
            class="auth-action--social"
            (click)="googleLogin()"
            [label]="'auth.login.button.sign_in_with_google' | translate"
    >
    </button>
  </div>
  <div class="col-12 p-fluid">
    <button pButton pRipple
            icon="pi pi-plus"
            iconPos="left"
            type="button"
            class="auth-action--secondary"
            [routerLink]="['/registration']"
            [label]="'auth.login.button.sign_up' | translate">
    </button>
  </div>
</form>
